import React from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row,
} from "reactstrap";
import logo from "assets/img/loginLogo.png";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import SocketEngine from "../../core/SocketEngine";
import { applyClaims } from "../../core/session";
import { HollowDotsSpinner } from "react-epic-spinners";
import strings from "../../core/translate";

class Login extends CoreEngine {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      loading: false,
    };
    this.engine = new RequestEngine();
  }

  // This method will decode the JWT token
  parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }

  componentWillUnmount() {
    document.body.classList.toggle("login-page");
  }

  async login() {
    const { email, password } = this.state;

    try {
      this.setState({ loading: true });

      const result = await this.engine.login(email, password);
      if (result.status === 201) {
        const accessToken = result.data.accessToken;

        if (!accessToken) {
          alert("Login successful but access token is missing");
          this.setState({ password: "", loading: false });
          return;
        }

        const decodedToken = this.parseJwt(accessToken);
        const merchantId = decodedToken.merchantId;

        // scopes, job statuses, merchant and pinned garage all come straight
        // from the token: writing them only when present let a previous
        // session's permissions survive this login
        applyClaims(decodedToken);

        if (merchantId) {
          await this.fetchMerchantScopes(merchantId);
        }
        // Store the token and managertype in sessionStorage
        sessionStorage.setItem("token", accessToken);
        sessionStorage.setItem("isloggedin", true);
        SocketEngine.connect();
        // push permission is requested once landing on /admin, in Admin.jsx —
        // it covers this redirect and every later reload/reopen the same way

        // everyone lands on the dashboard: it works for a garage and an admin
        this.props.history.push("/admin/dashboard");
      } else {
        alert("Wrong login info");
        this.setState({ password: "" });
      }
    } catch (e) {
      console.error("Error during login:", e);
      alert("Wrong login info");
      this.setState({ password: "", loading: false });
    }

    this.setState({ loading: false });
  }
  async fetchMerchantScopes(merchantId) {
    try {
      const response = await this.engine.getItem(
        `merchants/${merchantId}/scopes`
      );

      if (response && response.status === 200) {
        const merchantScopes = response.data;
        sessionStorage.setItem(
          "Merchantscopes",
          JSON.stringify(merchantScopes)
        );
      } else {
        console.error(
          "Failed to fetch merchant scopes. Status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching merchant scopes:", error);
    }
  }

  changeInput = (e, field) => {
    const value = e.target.value;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    this.setState({ [field]: trimmedValue });
  };

  render() {
    const { email, password, loading } = this.state;
    return (
      <div className="login-page">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" lg="4" md="6">
              <Form className="form">
                <Card className="card-login">
                  <CardHeader>
                    <div className="logo-img">
                      <img src={logo} alt="react-logo" className="innerLogo" />
                    </div>
                  </CardHeader>
                  <CardBody>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="nc-icon nc-single-02" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder={strings.email_or_username}
                        value={email}
                        onChange={(e) => this.changeInput(e, "email")}
                        type="text"
                      />
                    </InputGroup>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="nc-icon nc-key-25" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder={strings.password}
                        type="password"
                        autoComplete="off"
                        value={password}
                        onChange={(e) => this.changeInput(e, "password")}
                      />
                    </InputGroup>
                    <br />
                  </CardBody>
                  <CardFooter>
                    {loading ? (
                      <div className="logo-img">
                        <HollowDotsSpinner
                          color="#51BCDA"
                          animationDelay={50}
                        />
                      </div>
                    ) : (
                      <Button
                        block
                        className="btn-round mb-3"
                        style={{ background: "#ff4314" }}
                        onClick={() => this.login()}
                      >
                        Login
                      </Button>
                    )}
                  </CardFooter>
                </Card>
              </Form>
            </Col>
          </Row>
        </Container>
        <div
          className="full-page-background"
          style={{
            backgroundImage: `url(${require("assets/img/bg/login_bg.jpg")})`,
          }}
        />
      </div>
    );
  }
}

export default Login;
